"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportWrapper = void 0;
const React = __importStar(require("react"));
const kendo_react_excel_export_1 = require("@progress/kendo-react-excel-export");
const ZButton_1 = require("../ZButton/ZButton");
const styled_components_1 = __importDefault(require("styled-components"));
exports.ExportWrapper = (props) => {
    const exportRef = React.useRef(null);
    const [exportData, setExportData] = React.useState(null);
    const ExportButton = styled_components_1.default(ZButton_1.ZButton) `
      float: right !important;
   `;
    const runfetch = () => {
        props.getExportData().then((result) => setExportData(result));
    };
    const doExport = (data) => {
        exportRef.current && exportRef.current.save(data);
    };
    React.useEffect(() => {
        if (exportData) {
            doExport(exportData);
            setExportData(null);
        }
    }, [exportData]);
    return props.excelExport ? (React.createElement(React.Fragment, null,
        React.createElement(kendo_react_excel_export_1.ExcelExport, { ref: exportRef }, props.children),
        React.createElement(ExportButton, { onClick: runfetch }, "ExportToExcel"))) : (props.children);
};
//# sourceMappingURL=ZExport.js.map